import _ from 'underscore';
import BaseView from '../../../base-view';
import template from './template.html';

export default BaseView.extend({
	destroyTimeout: null,

	events: {},

	template: _.template(template),

	initialize: function(options) {
		// remove view when model is destroyed
		this.listenTo(this.model, 'destroy', this.remove);
	},

	render: function() {
		// set element to ommit div-wrapper
		// http://backbonejs.org/#View-setElement
		this.setElement(this.template(this.model.toJSON()));
		return this;
	}
});

